"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.datePart = datePart;
/**
 * zwraca liczbę reprezetującą częśc daty
 * @param date data w formacie yyyy-MM-dd HH:mm:ss
 * @param part rok:y,yy,yyy,year;
 * miesiąc:M,MM,month;
 * dzien:d,dd,day;
 * godzina:h,hh,hour;
 * minuta:m,mm,minute;
 * sekunda:s,ss,second;
 */
function datePart(date, part) {
    switch (part) {
        case 'y':
        case 'yy':
        case 'yyyy':
        case 'year':
            return typeof date === 'string' ? _getInt(date, 0, 4) : date.getFullYear();
        case 'M':
        case 'MM':
        case 'month':
            return typeof date === 'string' ? _getInt(date, 5, 2) : date.getMonth() + 1;
        case 'd':
        case 'dd':
        case 'day':
            return typeof date === 'string' ? _getInt(date, 8, 2) : date.getDate();
        case 'h':
        case 'hh':
        case 'hour':
            return typeof date === 'string' ? _getInt(date, 11, 2) : date.getHours();
        case 'm':
        case 'mm':
        case 'minute':
            return typeof date === 'string' ? _getInt(date, 14, 2) : date.getMinutes();
        case 's':
        case 'ss':
        case 'second':
            return typeof date === 'string' ? _getInt(date, 17, 2) : date.getSeconds();
        default:
            return 0;
    }
}
function _getInt(s, start, length) {
    if (start < s.length) {
        return +s.substring(start, length + start);
    }
    return 0;
}
//# sourceMappingURL=datePart.js.map